<template>
  <div data-testid="cartGrid">
    <div class="bg-white md:grid md:grid-cols-cart-layout">
      <div class="p-3 border-b justify-between uppercase text-black font-bold hidden md:flex">
        <span>Product</span>
        <span class="hidden lg:block">Price</span>
      </div>
      <div class="p-3 border-b uppercase text-black font-bold hidden text-center md:block">QTY</div>
      <div class="p-3 border-b uppercase text-black font-bold hidden text-center md:block">Subtotal</div>

      <template v-for="(cartItem, index) in filteredCartItems" :key="cartItem.lineId">
        <template v-if="index > 0">
          <div class="border-t col-span-full my-3 lg:m-3"></div>
        </template>
        <CheckoutCartItem :cart-item="cartItem" />
      </template>
    </div>

    <template v-if="$device.value.isDesktop">
      <CheckoutCartRecommendations v-if="inExperiment && firstCartItem" :item-id="firstCartItem" />

      <div v-if="isIntegrationEnabled('cognito')">
        <Wishlist>
          <template #default>
            <div class="my-4 capitalize text-3xl font-bold">Saved Items</div>
          </template>
        </Wishlist>
      </div>
      <CheckoutNeedHelp />
    </template>
  </div>
</template>

<script setup lang="ts">
const { $speedcurve, $uiEvents, $extend } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const { translateTemplate } = useTemplateTranslator()
const amplitude = useAmplitude()

const inExperiment = ref(false)
// A/B test for Cart Recommendations UWP-13964
amplitude.onReady({
  experimentId: 'cart-rec-tray',
  callback: (variant) => {
    if (variant.value !== 'treatment') return
    inExperiment.value = true
  },
})

const cart = useCart()

const filteredCartItems = computed(() => {
  return !isIntegrationEnabled('extend')
    ? cart.state.value.items
    : $extend.getCartItemsExcludingShippingProtection(cart.state.value.items)
})

const firstCartItem = computed(() => {
  return filteredCartItems.value[0]?.productLineSlug
})

useMetaTags({
  title: translateTemplate('Cart [TITLE_SUFFIX]'),
  isNoIndex: true,
})

onMounted(() => {
  $uiEvents.$emit('cartViewed')
})

onBeforeMount(() => {
  $speedcurve.track('Cart Page')
})
</script>
